(function ($) {
    $(window).on('load resize', function () {
        if ($(window).width() < 992) {
            openSearchModal();
        } else {
            closeSearchModal();
        }

        $("#searchModal .closeBtn").on('click', function () {
            closeSearchModal();

            return false;
        });

        // Close search modal (results modal will appear right after)
        $("#searchModal .searchButton").on('click', function () {
            closeSearchModal();
        });

        function openSearchModal() {
            $("[data-modal-id='searchModal']").on('click', function (event) {
                event.preventDefault();
                var modalBox = $(this).attr("data-modal-id");
                $("#" + modalBox).fadeIn();
                $(".modalCover").fadeIn("fast");
                trap_focus($('#searchModal'), 'searchModal');
                $("#searchModal .searchInput").focus();
                $('body').css('overflow', 'hidden');
                return false;
            });
        }

        function closeSearchModal() {
            var modal = $("#searchModal");

            if (modal.is(':visible')) {
                modal.fadeOut("fast");
                $(".modalCover").fadeOut();
                remove_trap_focus($('#searchModal'), 'searchModal');
                $("#searchBtn").trigger('focus');
                $('body').css('overflow', '');
            }
        }
    });

    $(document).on('ready', function () {
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                // get the added nodes in the DOM
                var nodes = Array.prototype.slice.call(mutation.addedNodes);
    
                nodes.forEach(function (node) {
                    // select the option element has "Select Language"
                    if ($(node).is('#cludo-search-results')) {
                        if ($(window).width() < 992) {
                            remove_trap_focus($('#searchModal'), 'searchModal');
                            trap_focus($('#cludo-search-results'), 'cludoFocus');
                        }
                    }
                });
            });
        });
    
        // listen to the node changes within #google_translate_element element
        observer.observe(document.querySelector("body"), {
            childList: true,
            subtree: true,
            attributes: false,
            characterData: false,
        });

        var observer = new MutationObserver(function (mutations) {
            $(mutations).each(function () {
                var me = $(this);
        
                $(me[0].removedNodes).each(function () {
                    var removed = $(this);
        
                    if (removed.attr('id') === 'cludo-search-results') {
                        remove_trap_focus($('#cludo-search-results'), "cludoFocus");
                        trap_focus($('#searchModal'), 'searchModal');
                        $('#searchModal .searchInput').trigger('focus');
                    }
                })
            })
        });
    
        // listen to the node changes within #google_translate_element element
        observer.observe(document.querySelector("body"), {
            childList: true,
            subtree: true,
            attributes: false,
            characterData: false,
        });
    });
})(jQuery);